import classNames from 'classnames/bind';
import styles from './Information.module.css';

import { useAppSelector } from '../../../hooks/useRedux';
import useModal from '../../../hooks/useModal';
import { useSlice } from '../../../hooks/useSlice';
import { selectMenu } from '../../../features/infoSlice';

import Button from '../../Button';
import InformationItem from '../InformationItem';
import {
  EDIT,
  DETAILS_LIST_TITLE,
  SHARE_INFO,
  PUBLIC_INFO,
  FOLDER_INFO,
} from '../../../constants';
import { LibraryKey } from '../../../types/library';
import TipButton from '../../TipButton';
import { TooltipWrapper } from '../../Tooltip';

interface Section {
  dataKey: LibraryKey;
  subKey?: 'file' | 'web';
}

export default function Information({ dataKey, subKey }: Section) {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const { toggleModal } = useModal();
  const { selectSelectedItem } = useSlice();
  const selectedItem = useAppSelector(selectSelectedItem);
  const isFolder = selectedItem?.resource?.ext === 'folder';
  const hasEditList = [
    'project',
    'projectCopyright',
    'projectIndex',
    'projectShare',
    'projectPublic',
    'projectHistoryList',
    'resource',
    'url',
    'share',
  ];
  const hasEdit =
    hasEditList.includes(dataKey) &&
    (menu === 'library' ||
      menu === 'mydrive' ||
      (menu === 'share' && dataKey === 'projectHistoryList')) &&
    !isFolder;
  const hasShareInfo = dataKey === 'projectShare' && menu === 'share';
  const title = hasShareInfo
    ? SHARE_INFO
    : dataKey === 'projectPublic' && menu === 'search'
    ? PUBLIC_INFO
    : dataKey === 'resource' && isFolder
    ? FOLDER_INFO
    : DETAILS_LIST_TITLE[dataKey];

  const openEditModal = () =>
    toggleModal({
      name: `${dataKey}_edit`,
      id: dataKey,
      type: 'alert',
      subKey,
    });

  return (
    <div className={cx('panel', dataKey)}>
      <div className={cx('panel_title')}>
        <span>
          {title}
          {hasShareInfo && <TipButton name="shareInfo" />}
          {(dataKey === 'projectResource' || dataKey === 'resource') && (
            <TipButton name="fileInfo" />
          )}
        </span>
        {hasEdit && (
          <TooltipWrapper content={EDIT} onClick={openEditModal}>
            {(tooltipProps) => (
              <Button
                name={EDIT}
                classnames={['panel_editor']}
                isBlindName={true}
                tooltipProps={tooltipProps}
              />
            )}
          </TooltipWrapper>
        )}
      </div>
      <div className={cx('panel_inner')}>
        <InformationItem dataKey={dataKey}></InformationItem>
      </div>
    </div>
  );
}
